__turbopack_context__.v({
  "homePointsButton": "home-points-module-scss-module__IlOmyW__homePointsButton",
  "homePointsCheckmark": "home-points-module-scss-module__IlOmyW__homePointsCheckmark",
  "homePointsImage": "home-points-module-scss-module__IlOmyW__homePointsImage",
  "homePointsList": "home-points-module-scss-module__IlOmyW__homePointsList",
  "homePointsListItem": "home-points-module-scss-module__IlOmyW__homePointsListItem",
});
